function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M82.1,42.1L80,37.8c-0.5-0.8,0.1-2.1,0-3.1c-1.6-18-16.7-32.2-35.1-32.2C25.4,2.5,9.6,18.3,9.6,37.8 c0,11.6,5.6,22.9,14.2,30.3c1,0.9,1.7,2.1,1.7,3.5v12.1c0,1.6,3.6,3.6,5.2,3.8l27.9,10.1c1.8,0.2,3.3-1.3,3.3-3.1V80.1 c0-0.9,0.8-1.7,1.7-1.7h10.6c3.3,0,4.5-3.8,4.5-7.1l1.4-13c0-0.6,3.5-0.1,4.2-0.1l2.4-0.4C90.3,53.8,83.8,44.7,82.1,42.1z  M59.9,42.6c-1.5,0-2.8-0.4-4.2-1C54,43.3,53.6,45,50.9,45c-1.1,0-0.6,1.7-1.6,1.5c-1.4,2-7.5,5.2-10.1,5.2c-0.1,0-1.2,8.8-6,9.9 c0,0-4.7-2-4.6-3.1c0.2-4.2-0.5-4.8-1.2-9c-4.1-0.7-7.3-4.2-7.3-8.5c0-0.6,0.1-1.1,0.1-1.7c-2.5-1.6-4.1-4.2-4.1-7.4 c0-4,2.7-7.3,6.3-8.4c0.2-4.8,4.2-8.8,9.2-8.8c1.6,0,3.1,0.5,4.3,1.1c1.6-2.6,4.5-4.2,7.8-4.2c3.2,0,6.1,1.6,7.7,4.1 c0.9-0.2,1.9-0.5,2.8-0.5c4.8,0,8.7,3.7,9.2,8.3c3.7,1.5,6.3,5,6.3,9.3C69.8,38.1,65.4,42.6,59.9,42.6z"
})));

function SvgMindset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindset);
export default __webpack_public_path__ + "static/media/Mindset.656afbff.svg";
export { ForwardRef as ReactComponent };